import { map } from "lodash";
import React from "react";
import FilterChip from "../../../components/pages/SearchPage/components/FilterChip";
import { useRefinementList } from "react-instantsearch";
import FilterSection from "../../../components/pages/SearchPage/components/FilterSection";

type Props = {
  label: string;
  attribute: string;
  labelRender?: (label: string) => string;
};
export default function ChipFilter({ label, attribute, labelRender }: Props) {
  const { items, refine, canRefine } = useRefinementList({ attribute, limit: 100 });
  const selectedValues = items.filter((item) => item.isRefined).map((item) => item.value);
  const hasSelectedItems = selectedValues.length > 0;

  return (
    <FilterSection label={label} canRefine={canRefine} hasSelectedItems={hasSelectedItems}>
      <div className="t-searchFilterGroup">
        {map(items, (option) => (
          <FilterChip
            key={option.value}
            label={labelRender ? labelRender(option.label) : option.label}
            onClick={() => refine(option.value)}
            $selected={selectedValues.includes(option.label)}
            size="small"
          />
        ))}
      </div>
    </FilterSection>
  );
}
